import React, { useState, useEffect, useRef } from 'react';
import { renderParagraph, IsOnMobile } from 'components/utils';
import { Button } from 'components/common';
import TcamPear from './TcamPear';
import { Wrapper, Container, Top, Bottom, Content, Heading, ButtonContainer, ButtonAddText, Paragraph, PearContainer, PearMobile, FloatingDiv, FloatingContainer } from './TcamWiggle.style';

interface Props {
    heading: string;
    paragraph: any;
    btnText: string;
    btnAddText: string;
    btnLink: string;
}

const TcamWiggle: React.FC<Props> = ({ heading, paragraph, btnText, btnAddText, btnLink }) => {
    const divRef = useRef(null);
    const [isElementVisible, setIsElementVisible] = useState(false);
    const isOnMobile = IsOnMobile();

    useEffect(() => {
        const options = {
          root: null,
          rootMargin: '0px',
          threshold: 0.3, // percentage of the element must be visible
        };
    
        const observer = new IntersectionObserver(([entry]) => {
          setIsElementVisible(entry.isIntersecting);
        }, options);
    
        if (divRef.current) {
          observer.observe(divRef.current);
        }
    
        return () => {
          if (divRef.current) {
            observer.unobserve(divRef.current);
          }
        };
      }, [divRef]);
  
    
    return (
      <Wrapper>
        <Container ref={divRef}>
            <Top>
                <Content>
                    <Heading>{heading}</Heading>
                    {!isOnMobile &&
                      <ButtonContainer>
                        <ButtonAddText>{btnAddText}</ButtonAddText>
                        { btnText?.trim() && <Button {...{ btnType: 'tcamUp', btnText, ...(btnLink.trim() && { btnLink }) }} /> }
                      </ButtonContainer>
                    }
                </Content>
                {(!isOnMobile) && 
                  <PearContainer>
                      <TcamPear hasAnimation={true} {...btnLink.trim() ? {link: btnLink} : {}}/>
                  </PearContainer>
                }
            </Top>
            <Bottom>
                <Paragraph>{renderParagraph(paragraph)}</Paragraph>
                {isOnMobile &&
                  <PearMobile>
                    <ButtonContainer>
                      <ButtonAddText>{btnAddText}</ButtonAddText>
                      { btnText?.trim() && <Button {...{ btnType: 'tcamDown', btnText, ...(btnLink.trim() && { btnLink }) }} /> }
                    </ButtonContainer>
                  </PearMobile>
                }
            </Bottom>
            { !isElementVisible &&
            <FloatingDiv>
                <FloatingContainer>
                    <TcamPear hasScrollAnimation={true} {...btnLink.trim() ? {link: btnLink} : {}}/>
                    {btnText?.trim() && <Button {...{btnType: 'tcam', btnText, ...(btnLink.trim() && { btnLink })}} /> }
                </FloatingContainer>
            </FloatingDiv>
            }
        </Container>
        {isOnMobile &&
          <PearContainer>
            <TcamPear hasAnimation={true} {...btnLink.trim() ? {link: btnLink} : {}} />
          </PearContainer>
        }
        </Wrapper>
    );
};

export default TcamWiggle;